$(function(){
    if($('.page--login').length == 0){

        function toggleComparePanel(){
            var show = $(".compare-panel").attr("show");
            if(show === "true"){
                $(".compare-panel").css("right", (-1 * pannelWidth) + "px");
                $(".compare-panel").attr("show", "false");
            }else{
                $(".compare-panel").css("right", "0px");
                $(".compare-panel").attr("show", "true");
            }
        }

        function hideComparePanel(){
            var show = $(".compare-panel").attr("show");
            if(show === "true"){
                var memory = JSON.parse(localStorage.getItem('compareProducts'));
                if(memory.length != 0){
                    $(".compare-panel").css("right", (-1 * pannelWidth) + "px");
                }

                $(".compare-panel").attr("show", "false");
            }
        }

        function toggleProductCompareList(data){
            var memory = localStorage.getItem('compareProducts');
            if(!memory){
                memory = [data];
            }else{
                memory = JSON.parse(memory);
                var found = false;
                for(var i = 0 ; i < memory.length; i++){
                    if(data.ID == memory[i].ID){
                        found = true;
                        memory.splice(i, 1);
                    }
                }
                if(!found){
                    console.log(data.length);
                    if(memory.length == 3){
                        throw "Maximum compare items added!";
                    }
                    memory.push(data);
                }
            }
            localStorage.setItem('compareProducts', JSON.stringify(memory));
            updateCompareUI();
        }

        function removeFromProductCompareList(data){
            console.log('removeFromProductCompareList');
            var memory = localStorage.getItem('compareProducts');
            if(!memory){
                return;
            }else{
                memory = JSON.parse(memory);
                var found = false;
                for(var i = 0 ; i < memory.length; i++){
                    if(data.ID == memory[i].ID){
                        found = true;
                        memory.splice(i, 1);
                    }
                }
                if(!found){
                    return;
                }
            }
            localStorage.setItem('compareProducts', JSON.stringify(memory));
            updateCompareUI();
        }

        function addToProductCompareList(data){
            console.log('addToProductCompareList');

            var memory = localStorage.getItem('compareProducts');
            if(!memory){
                memory = [data];
            }else{
                memory = JSON.parse(memory);
                console.log(memory);
                if(memory.length >= 3){
                    throw "Maximum compare items added!";
                }
                var found = false;
                for(var i = 0 ; i < memory.length; i++){
                    if(data.ID == memory[i].ID){
                        found = true;
                        return;
                    }
                }
                if(!found){
                    memory.push(data);
                }
            }
            localStorage.setItem('compareProducts', JSON.stringify(memory));
            updateCompareUI();
        }


        $(document).click(function(event) {
            if(!$(event.target).hasClass('compare-panel-btn-inner') && !$(event.target).hasClass('remove-icon')){
                var parent = $(event.target).parent('.compare-panel');
                if(parent.length == 0){
                    hideComparePanel();
                }
            }
        });

        $(document).on('click', '.remove-btn-container', function(){
            var id = $(this).attr('data-id');
            toggleProductCompareList({
                ID: id
            });
        });

        $(document).on('change', '.compare-model-checkbox', function(){
            var data = $(this).data('model');
            var id = $(this).attr('id');
            console.log(id);

            $(this).attr('checked', false);
            if($(this).is(':checked')){
                try {
                    addToProductCompareList(data);
                } catch(err) {
                    $(this).prop('checked', false);
                    toast('Maximum number of compared products added');
                }

            }else{
                removeFromProductCompareList(data);
            }
        });



        $('body').append('<div style="right: ' + (-1 * pannelWidth - 50) + 'px" class="compare-panel" show="false"><div class="compare-panel-btn"><div class="compare-panel-btn-inner">Compare <span>1</span></div></div><div class="compare-panel-content"></div><div class="compare-btn-container txt-center" ><a class="btn btn-bg-red btn-danger compare-link" href="/compare/">Compare</a></div><div>')

        $('.compare-panel-btn').click(function(){
            toggleComparePanel();
        });

        $('.compare-model-btn').click(function(e){
            e.preventDefault();
            var data = $(this).data('model');

            try {
                toggleProductCompareList(data);
            } catch(err) {
                $(this).prop('checked', false);
                toast('Maximum number of compared items added');
            }
        });

        $(".remove-compare-product-btn").click(function(){
            var id = $(this).attr('data-id');
            toggleProductCompareList({
                ID: id
            });

            var memory = JSON.parse(localStorage.getItem('compareProducts'));
            if(memory.length == 0){
                location.href = "/";
            }else{
                var ids = "";
                for(var i = 0; i < memory.length; i++){
                    ids += memory[i].ID + '-';
                }
                if(ids.length > 1){
                    ids = ids.slice(0, -1);
                }
                location.href = "/compare/" + ids;
            }

        });

        updateCompareUI();
    }

});
var pannelWidth = 250;
function updateCompareUI(){
    var memory = localStorage.getItem('compareProducts');
    $('.compare-model-btn').removeClass('active');
    if(memory){
        var memory = JSON.parse(localStorage.getItem('compareProducts'));
        $(".compare-panel-content").html('');
        var ids = "";
        for(var i = 0; i < memory.length; i++){
            var model = memory[i];
            var id = model.ID;
            ids += id + '-';
            $(".compare-model-btn[data-id='" + model.ID + "']").addClass('active');
            $(".compare-model-checkbox[data-id='" + model.ID + "']").attr('checked', true);
            $(".compare-panel-content").append('<div class="compare-item">'
                + '<div class="remove-btn-container" data-id="' + model.ID + '"><i class="remove-icon fa fa-times" ></i></div>'
                + '<div class="model-title">' + model.Name + '</div>'
                + '<div class="range-title small">' + model.RangeName + '</div>'
                + '<div class="model-photo"><img src="' + model.PhotoURL + '"></div>'
                + '</div>');
        }
        if(ids.length > 1){
            ids = ids.slice(0, -1);
        }

        $('.compare-link').attr('href', '/compare/' + ids);

        if(memory.length > 0){
            $(".compare-panel-btn-inner span").html(memory.length);
            if($('.compare-panel').attr('show') != 'true'){
                $('.compare-panel').css('right', (-1 * pannelWidth) + "px");
            }
        }else{
            $('.compare-panel').css('right', (-1 * pannelWidth - 50) + "px");
        }
    }
}